import React, { useEffect, useState } from 'react';
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Button from "../Elements/Button";

const SectionTechniqueDetailsHebergeur = () => {
    let { id } = useParams();
    id = parseInt(id);

    const [provider_id, setProviderId] = useState('');
    const [customProvider, setCustomProvider] = useState('');
    const [providersName, setProvidersName] = useState([]);
    const [showOtherProvider, setShowOtherProvider] = useState(false);
    const [allFetched, setAllFetched] = useState(false);

    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_providers_name/`)
            .then(res => {
                setProvidersName(res.data.result);
                setAllFetched(true);
            })
            .catch(err => console.error('Erreur get_providers_name :', err));
    }, []);

    useEffect(() => {
        if (!allFetched) return;

        axios.post(`${API_BASE_URL}/get_customer_provider/`, { id })
            .then(res => {
                const storedProvider = res.data.results;

                // Si vide ou null : aucun provider sélectionné
                if (!storedProvider) {
                    setProviderId('');
                    setCustomProvider('');
                    setShowOtherProvider(false);
                    return;
                }

                const match = providersName.find(p => p.name === storedProvider);

                if (match) {
                    setProviderId(match.id.toString());
                    setShowOtherProvider(false);
                    setCustomProvider('');
                } else {
                    // Cas "Autre" : valeur non trouvée dans la liste
                    const other = providersName.find(p => p.name === "Autre");
                    if (other) {
                        setProviderId(other.id.toString());
                        setShowOtherProvider(true);
                        setCustomProvider(storedProvider);
                    }
                }
            })
            .catch(err => console.error('Erreur get_customer_provider :', err));
    }, [allFetched, providersName, id]);

    useEffect(() => {
        const selected = providersName.find(p => p.id.toString() === provider_id);
        setShowOtherProvider(selected?.name === "Autre");

        if (selected?.name !== "Autre") {
            setCustomProvider('');
        }
    }, [provider_id, providersName]);

    const changeProvider = (id) => {
        setProviderId(id);
    };

    const handleCustomProvider = (e) => {
        setCustomProvider(e.target.value);
    };

    const saveProvider = () => {
        const selected = providersName.find(p => p.id.toString() === provider_id);
        const providerName = selected?.name === "Autre" ? customProvider : selected?.name;

        axios.post(`${API_BASE_URL}/set_customer_provider/`, {
            customer_id: id,
            customer_provider: providerName
        })
            .then(res => {
                toast.success("Fournisseur mis à jour.");
            })
            .catch(err => {
                toast.error("Une erreur est survenue lors de l'enregistrement.");
                console.error('Erreur enregistrement :', err);
            });
    };

    return (
        <>
            <ToastContainer position="bottom-right" autoClose={3000} />
            <div className="display-flex flex-direction-column gap-20">
                <div className="display-flex gap-20 flex-direction-column">
                        <h3 className={"color-third"}>Hébergeur web</h3>

                    <div className={"h-separator"}/>

                    <h4 className={"color-third"}>Fournisseur de services</h4>

                    <select
                        onChange={(e) => changeProvider(e.target.value)}
                        value={provider_id}
                        className="input p-10"
                    >
                        <option value="">-- Sélectionner --</option>
                        {providersName.map((provider) => (
                            <option key={provider.id} value={provider.id}>
                                {provider.name}
                            </option>
                        ))}
                    </select>

                    {showOtherProvider && (
                        <input
                            className="crop-text input p-10"
                            placeholder="Nom du fournisseur"
                            value={customProvider}
                            onChange={handleCustomProvider}
                        />
                    )}
                </div>
                <Button onClick={saveProvider} icon={"fa-floppy-disk"}
                        label={"Enregistrer"}
                        textClassNames={"bg-third text-white btn-save"}
                        iconBackground={'bg-fifth'} disableLink/>
            </div>


        </>
    );
};

export default SectionTechniqueDetailsHebergeur;
